import React, { useEffect } from 'react';
import {
  Box,
  Button,
  ButtonSize,
  Icon,
  IconName,
  Text,
  Tooltip,
} from '@usealloy/component-library';
import $ from 'jquery';

import type { EntityData, EntityPiiData, MatchData } from '../../types';
import {
  MatchDetailSummaryCard, MatchHeaderStyledBox,
} from '~/entities/evaluations/watchlist-review/styles';
import { normalToSnake } from './helpers';
import UnsupportedMatchDetailSummary from './components/UnsupportedMatchDetailSummary';
import SupportedMatchDetailsSummary from './components/SupportedMatchDetailSummary';

type MatchDetailSummaryProps = {
  service: string;
  height: number;
  match: MatchData;
  entity: EntityData;
  entityPii: EntityPiiData;
  isSupportedService: boolean;
};

export const MatchDetailSummary = ({
  service,
  height,
  match,
  entity,
  entityPii,
  isSupportedService,
}: MatchDetailSummaryProps) => {
  const handleClickMatchType = (label: string) => {
    const wrapper = document.querySelector('[data-watchlist-container="scroller"]') as HTMLElement;
    if (!wrapper) return;
    const key = normalToSnake(label);
    const dom = document.querySelector(`[data-watchlist-section=${key}]`);
    if (!dom) return;
    const scrollTop = (dom as HTMLElement).offsetTop - wrapper.offsetTop;
    $(wrapper).animate({ scrollTop }, 300);
  };

  useEffect(() => {
    const wrapper = document.querySelector('[data-watchlist-container="scroller"]') as HTMLElement;
    if (!wrapper) return;
    wrapper.addEventListener('scroll', e => {
      const header = document.querySelector('[data-watchlist-matches-component="header"') as HTMLDivElement;
      if (!header) return;
      if ((e.target as HTMLElement).scrollTop > 10) {
        header.classList.add('shadowed');
      } else {
        header.classList.remove('shadowed');
      }
      // as it's attached to a dom, doesn't need removeEventListener
    });
  }, [match]);

  return (
    <MatchDetailSummaryCard data-testId="match-detail-summary" height={height} id="watchlist-match-detail-hits">
      <MatchHeaderStyledBox data-watchlist-matches-component="header">
        <Box justifyContent="flex-start">
          <Icon icon={IconName.TriangleWarning} />
          <Text lineHeight={4} size={3} weight={700}>
            {match.service || service} Matches
          </Text>
        </Box>
        {!!match.match_types.length && (
          <Box data-testId="match-detail-summary-nav" gap={1} justifyContent="flex-start" wrap="wrap">
            {match.match_types.map(({ label, values }) => (
              <Tooltip
                side="top"
                key={label}
                content={values.join(', ')}
                hide={values.length < 2}
              >
                <Button
                  onClick={() => handleClickMatchType(label)}
                  size={ButtonSize.xsmall}
                  data-dd-action-name={`alloydd-watchlistDetail-jumpToSection-${label}`}
                >{label}
                </Button>
              </Tooltip>
            ))}
          </Box>
        )}
      </MatchHeaderStyledBox>
      {
        isSupportedService ? (
          <SupportedMatchDetailsSummary
            match={match}
            entity={entity}
            entityPii={entityPii}
          />
        ) : (<UnsupportedMatchDetailSummary match={match} />)
      }
    </MatchDetailSummaryCard>
  );
};
